import { X, Download, Tag, Bell, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface InstallPromptProps {
  onInstall: () => void;
  onDismiss: () => void;
}

export function InstallPrompt({ onInstall, onDismiss }: InstallPromptProps) {
  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-4 md:w-96 animate-in slide-in-from-bottom">
      <Card className="border-primary shadow-glow">
        <CardHeader className="relative">
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-2 top-2 h-6 w-6"
            onClick={onDismiss}
          >
            <X className="h-4 w-4" />
          </Button>
          <div className="flex items-center gap-2">
            <Download className="h-5 w-5 text-primary" />
            <CardTitle className="text-lg">Install SabiTrade App</CardTitle>
          </div>
          <CardDescription>
            Get exclusive benefits for app users only!
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <div className="flex items-start gap-3">
              <Tag className="h-5 w-5 text-success mt-0.5" />
              <div>
                <p className="font-medium text-sm">Exclusive Early Access</p>
                <p className="text-xs text-muted-foreground">
                  Get notified 24 hours before sales go live
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Badge variant="outline" className="bg-success/10">
                <span className="text-success font-semibold">5% OFF</span>
              </Badge>
              <div>
                <p className="font-medium text-sm">First Purchase Discount</p>
                <p className="text-xs text-muted-foreground">
                  Use code APP5 on your first order via app
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Bell className="h-5 w-5 text-warning mt-0.5" />
              <div>
                <p className="font-medium text-sm">Instant Notifications</p>
                <p className="text-xs text-muted-foreground">
                  Track orders and get updates in real-time
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Zap className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <p className="font-medium text-sm">Faster Shopping</p>
                <p className="text-xs text-muted-foreground">
                  Quick access, no browser needed
                </p>
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            <Button onClick={onInstall} className="flex-1">
              <Download className="h-4 w-4 mr-2" />
              Install Now
            </Button>
            <Button variant="outline" onClick={onDismiss}>
              Later
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
